import React from 'react';
import Newsletter from '../../Components/NewsLetter/Newsletter';
import OurCook from './OurCook';
import PopularDishes from './PopularDishes';
import TopBanner from './TopBanner';
import WhatWeDoing from './WhatWeDoing';
import WhatYouLike from './WhatYouLike';

const Home = () => {
    return (
        <div>
            <TopBanner/>
            <WhatWeDoing/>
            <WhatYouLike/>
            <PopularDishes/>
            <OurCook/>
            <Newsletter/>
        </div>
    );
};

export default Home;